import { Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export default function BreadcrumbLink({ href, children }) {
    const history = useHistory();

    return <Breadcrumb.Item href={href} onClick={e => (e.preventDefault(), history.push(href))}>{children}</Breadcrumb.Item>
}